import { useParams } from 'react-router-dom';
import ProductHero, { ProductContainer } from '../components/product/ProductHero';
import ProductBody from '../components/product/ProductBody';
import { getProductBySlug } from '../assets/products';
import { useI18n } from '../i18n';
import SeoHead from '../components/SeoHead';
import NotFoundPage from './NotFoundPage';
import { SITE_ORIGIN } from '../config/site';

const ProductPage = () => {
  const { productSlug } = useParams();
  const { locale } = useI18n();
  const productData = getProductBySlug(productSlug, locale);

  if (!productData) {
    return <NotFoundPage />;
  }

  const ogImage = productData.backgroundImage
    ? `${SITE_ORIGIN}${productData.backgroundImage}`
    : undefined;

  return (
    <>
      <SeoHead
        title={productData.meta.title}
        description={productData.meta.description}
        keywords={productData.meta.keywords}
        path={`/products/${productSlug}`}
        image={ogImage}
      />
      <ProductContainer>
        <ProductHero product={productData} />
        <ProductBody product={productData} slug={productSlug} />
      </ProductContainer>
    </>
  );
};

export default ProductPage;
